import Immutable from "immutable";

const LOAD = "overrideDays/LOAD";
const LOAD_SUCCESS = "overrideDays/LOAD_SUCCESS";
const LOAD_FAIL = "overrideDays/LOAD_FAIL";

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  overrideDays: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("overrideDays", action.res);

    case LOAD_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("overrideDays", []);
    default:
      return state;
  }
}

export const getOverride = (params) => async (dispatch, getState, api) => {
  try {
    if (params) {
      params = JSON.stringify(params);
    }
    dispatch({ type: LOAD });
    const res = await api.get("/availabilityTracking/" + params);
    dispatch({ type: LOAD_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const addOverride = (data) => async (dispatch, getState, api) => {
  try {
    return await api.post("/availabilityTracking/save", { data });
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const deleteOverride =
  ({ id }) =>
  async (dispatch, getState, api) => {
    try {
      return await api.post("/availabilityTracking/toggle", { data: { id } });
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
      alert(err.message || "Failed to delete Override");
      throw err;
    }
  };
